import { render, staticRenderFns } from "./CustomerCustomerSession.vue?vue&type=template&id=37091566&scoped=true"
import script from "./CustomerCustomerSession.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerSession.vue?vue&type=script&lang=js"
import style0 from "./CustomerCustomerSession.vue?vue&type=style&index=0&id=37091566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37091566",
  null
  
)

export default component.exports